import faceshapePreview from "../assets/images/upsell-v2/faceshape.webp";
import hairstylePreview from "../assets/images/upsell-v2/hairstyle-two-rows.png";
import haircolorPreview from "../assets/images/upsell-v2/haircolor.webp";
import glassesPreview from "../assets/images/upsell-v2/glasses.webp";
import coloranalysisPreview from "../assets/images/upsell-v2/coloranalysis.webp";

// Production catalog and compatible receiver verified; controls new chains only.
// Rollback: set false while retaining V2 routes for chains already in progress.
export const UPSELL_V2_ENABLED = true;
export const UPSELL_V2_PAYMENT_BENEFIT =
  "One-time payment, no surprise renewals";
export const UPSELL_V2_PRODUCTS = Object.freeze({
  faceshape: Object.freeze({
    route: "/getoffer_faceshape",
    title: "Face Shape + Glasses & Makeup",
    cta: "Add Face Shape Offer",
    headline: "Get Your Face Shape Analysis with Glasses & Makeup Recommendations",
    guidance: "Smart guidance: glasses and makeup matched to your face shape",
    tryOn: "Try on glasses and makeup with AI before you commit",
    image: faceshapePreview,
    imageAlt: "Examples of face shapes with facial outlines",
    imageWidth: 880,
    imageHeight: 590,
    includes: Object.freeze(["Face Shape", "Glasses", "Makeup"]),
  }),
  hairstyle: Object.freeze({
    route: "/getoffer_hairstyle",
    title: "Hairstyle",
    headline: "Get the Best Hairstyles for Your Face Shape",
    guidance:
      "Smart guidance: hairstyles matched to your face shape and features",
    tryOn: "Try on hairstyles with AI before you commit",
    image: hairstylePreview,
    imageAlt: "Example hairstyle previews with different cuts and lengths",
    imageWidth: 1499,
    imageHeight: 1049,
  }),
  haircolor: Object.freeze({
    route: "/getoffer_haircolor",
    title: "Hair Color",
    headline: "Get the Best Hair Colors for Your Skin Tone",
    guidance:
      "Smart guidance: hair colors matched to your season and features",
    tryOn: "Try on hair colors with AI before you commit",
    image: haircolorPreview,
    imageAlt: "Example hair color previews in brown, blonde and copper",
    imageWidth: 880,
    imageHeight: 880,
  }),
  glasses: Object.freeze({
    route: "/getoffer_glasses",
    title: "Glasses",
    headline: "Get the Most Flattering Frames for Your Face",
    guidance: "Smart guidance: frames matched to your face shape and features",
    tryOn: "Try on glasses with AI before you commit",
    image: glassesPreview,
    imageAlt: "Examples of different glasses and frame shapes",
    imageWidth: 880,
    imageHeight: 880,
  }),
  coloranalysis: Object.freeze({
    route: "/getoffer_coloranalysis",
    title: "Color Analysis",
    headline: "Get Your Color Type for a More Flattering Wardrobe",
    guidance: "Smart guidance: outfits and hair by your season",
    tryOn: "Try on outfit and hair colors with AI before you commit",
    image: coloranalysisPreview,
    imageAlt: "Seasonal color palettes for spring, summer, autumn and winter",
    imageWidth: 880,
    imageHeight: 842,
  }),
});
export const UPSELL_V2_SEQUENCES = Object.freeze({
  coloranalysis: Object.freeze(["hairstyle", "haircolor", "faceshape"]),
  hairstyle: Object.freeze(["haircolor", "coloranalysis", "glasses"]),
  haircolor: Object.freeze(["hairstyle", "coloranalysis", "faceshape"]),
});
export const UPSELL_V2_ENTRY_ROUTES = Object.freeze({
  "/": "coloranalysis",
  "/v1": "coloranalysis",
  "/v2": "coloranalysis",
  "/month": "coloranalysis",
  "/v1_3months_upsell": "coloranalysis",
  "/colortype-3month-29": "coloranalysis",
  "/colortype-1month-29": "coloranalysis",
  "/colortype-3month-29-upsell": "coloranalysis",
  "/colortype-3month-29-upsell-v2": "coloranalysis",
  "/hairstyle": "hairstyle",
  "/hairstyle-3month-29-woman": "hairstyle",
  "/hair": "haircolor",
  "/haircolor-3month-29": "haircolor",
  "/haircolor-recomend-3month-29": "haircolor",
});
